import { render, staticRenderFns } from "./ActivationLinkError.vue?vue&type=template&id=ff3bb7d2&"
import script from "./ActivationLinkError.vue?vue&type=script&lang=ts&"
export * from "./ActivationLinkError.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports